'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _combineStyles = require('./combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPopOverPosition = function getPopOverPosition(button, popOver) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iconMenu';
  var _window = window,
      innerWidth = _window.innerWidth,
      innerHeight = _window.innerHeight;

  var halfButtonWidth = button.width / 2;

  var fitsAboveButton = button.top > popOver.height;
  var fitsRightFromButton = innerWidth - button.right - halfButtonWidth > popOver.width;
  var fitsLeftFromButton = button.left + halfButtonWidth > popOver.width;
  var fitsBelowButton = innerHeight - button.bottom > popOver.height;

  var horizontal = 'left';
  var vertical = 'bottom';

  if (fitsRightFromButton && !fitsLeftFromButton) {
    horizontal = 'right';
  }

  if (!fitsRightFromButton && !fitsLeftFromButton) {
    horizontal = 'middle';
  }

  if (fitsAboveButton && !fitsBelowButton) {
    vertical = 'top';
  }

  if (!fitsAboveButton && !fitsBelowButton) {
    vertical = 'middle';
  }

  var position = {
    position: 'fixed'
  };

  if (vertical === 'bottom') {
    position = (0, _combineStyles2.default)(position, { top: button.top + button.height, bottom: 'initial' });
  }

  if (vertical === 'top') {
    position = (0, _combineStyles2.default)(position, {
      top: 'initial',
      bottom: innerHeight - button.bottom + button.height
    });
  }

  if (vertical === 'middle') {
    var overflowsTop = popOver.height / 2 > button.top + halfButtonWidth;
    var overflowsBottom = popOver.height / 2 > innerHeight - button.bottom;

    position = (0, _combineStyles2.default)(position, {
      top: 'initial',
      bottom: innerHeight - button.bottom - popOver.height / 2 + button.height / 2
    });

    if (overflowsTop && !(popOver.height + 32 > innerHeight)) {
      position = (0, _combineStyles2.default)(position, { top: 16, bottom: 'initial' });
    }

    if (overflowsBottom && !(popOver.height + 32 > innerHeight)) {
      position = (0, _combineStyles2.default)(position, { top: 'initial', bottom: 16 });
    }
  }

  if (horizontal === 'left') {
    position = (0, _combineStyles2.default)(position, {
      left: 'initial',
      right: innerWidth - button.right + halfButtonWidth
    });
  }

  if (horizontal === 'right') {
    position = (0, _combineStyles2.default)(position, { left: button.left + halfButtonWidth, right: 'initial' });
  }

  if (horizontal === 'middle') {
    var overflowsLeft = popOver.width / 2 > button.left + halfButtonWidth;
    var overflowsRight = popOver.width / 2 > innerWidth - button.right;

    position = (0, _combineStyles2.default)(position, {
      left: button.right - popOver.width / 2,
      right: 'initial'
    });

    if (overflowsLeft && !(popOver.width + 32 > innerWidth)) {
      position = (0, _combineStyles2.default)(position, { left: 16, right: 'initial' });
    }

    if (overflowsRight && !(popOver.width + 32 > innerWidth)) {
      position = (0, _combineStyles2.default)(position, { left: 'initial', right: 16 });
    }
  }

  if (type === 'select') {
    position = (0, _combineStyles2.default)(position, { left: button.left, right: 'initial' });
  }

  return position;
};

exports.default = getPopOverPosition;
module.exports = exports.default;